module.exports = __webpack_public_path__ + "img/500x500px-ENTREVISTA.c42177ce.png";